import { createElement, Component, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import careersScene from 'helpers/scenes/careersScene';


export default class CareersPanel extends Component {

  initCareerScene () {
    careersScene();
  }

  componentDidUpdate () {
    this.initCareerScene();
  }

  componentDidMount () {
    this.initCareerScene();
  }

  render () {
    const { theme, careersCopy } = this.props;
    return (
      <section className="node node-single-page-section node-promoted view-mode-full">
        <article id="careers" className="layout-text bg-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Careers</h2>
              <div className={theme.CandidateNoticeLink} dangerouslySetInnerHTML={{__html: careersCopy}} />
            </div>
          </div>
        </article>
        <article id="current-vacancies" className="layout-standard text-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Current Vacancies</h2>
              <div className="view view-job-positions view-id-job_positions view-display-id-job_directory view-dom-id-9a8d3df4af0440d1debae513c70fd82e">
                <div className="view-content">
                  <div id="BambooHR" data-domain="relicentertainment.bamboohr.com" data-version="1.0.0" data-departmentId="" />
                  <script src="https://relicentertainment.bamboohr.com/js/embed.js" type="text/javascript" async defer />
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

CareersPanel.propTypes = {
  careersCopy: PropTypes.string,
};

themeable(CareersPanel, {
  classes: [
    'CandidateNoticeLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CareersPanel.jsx